import { AddressGroupService } from '../../../modules/customer/features/address-book/services/address-group.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import {
  FinishGetUserProfile,
  GetUserProfile,
  InitGetUserProfile,
} from '@core/state/userProfile/userProfile.actions';
import { tap } from 'rxjs/operators';
import { IUserProfileModel } from '../../../modules/user-profile/features/user-profile-page/models/user-profile.model';
import {
  FinishAddressGroups,
  GetAddressGroups,
} from '@core/state/address-group/address-group.actions';
import { IAddressGroup } from '@core/models/address-group';

@Injectable()
export class AddressGroupEffects {
  constructor(
    private actions$: Actions,
    private addressGroupService: AddressGroupService,
    private store: Store
  ) {}

  getAddressGroups$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GetAddressGroups),
        tap(() => {
          let addressGroups: IAddressGroup[] = [];
          this.store.dispatch(InitGetUserProfile());

          this.addressGroupService.getAddressGroups().subscribe({
            next: (res) => {
              if (res && res.success) {
                addressGroups = res.data;
              }
            },
            complete: () => {
              this.store.dispatch(FinishAddressGroups({ addressGroups }));
            },
          });
        })
      );
    },
    { dispatch: false }
  );
}
